const ID_TOKEN_KEY = "id_token" as string;

import oktaAuth from '@/auth';

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => {
  //return window.localStorage.getItem(ID_TOKEN_KEY);
  return oktaAuth.getAccessToken() as string;
};

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export default { getToken, saveToken, destroyToken };
